<template>
  <c-view>
    <c-page>
      <c-content>
        <div class="protocol-container">
          <div class="protocol-title text-center">生意专家服务说明</div>
          <div class="protocol-text">
            <div class="mt-20">
              生意专家提供的“行业版”服务，主要针对实体店的店铺管理。开通这项服务后，您可以拥有各类高效的工具，解决收银记账、会员管理、进销存等核心业务里的问题。
            </div>
            <div class="mt-10">
              在您购买完成后，服务即自动生效。但如果您有需要，我们可以为您寄送精美的“行业版”实体硬件，我们的服务是以实体卡的形势售卖的。
            </div>
            <div class="mt-10">
              我们还提供上门咨询服务及远程服务，您在使用过程中，有任何问题，随时联系我们。您可以在生意专家公众号里，联系我们的客服或拨打电话: <a class="text-color orange font-bold" href="tel:021-56380166">021-56380166</a>
            </div>
            <div class="mt-10">
              最终解释权归生意专家所有。
            </div>
          </div>
        </div>
      </c-content>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  export default {
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?3ec39c72